import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeRouteOfAdministrationType } from "../Entity/TreeNodeRouteOfAdministrationType";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeRoutesOfAdministrationList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new ListView(),
        'Routes of Administration ({param})'
      );
      this.parent = parent;
      this.labelNodeName = 'Routes Of Administration';      
      this.expanded = true;
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(params: any): Art57Node[] | null {
      let nodeCreated = new TreeNodeRouteOfAdministrationType(this.ioc!, this);
  
      if ((params.operationType===1) && (this.ioc!.get(Art57Section).isCreateAndSendProductSection() || this.ioc!.get(Art57Section).isMedicinalProductSection())) {
        nodeCreated.data.model.localnumber = this.ioc!.get(LookupGetService).getLocalNumber();
      }
      
      this.children?.push(nodeCreated);
      this.refreshLabel();
      nodeCreated.data.model.type_Term = params.nodeType;
      nodeCreated.refreshLabel();
  
  
      return [nodeCreated];
    }
  
    override getMessage(): any {
      let administrationroutes: any[] = [];
      this.children?.forEach((node) => {
        let administrationroute = node as TreeNodeRouteOfAdministrationType;
        let art57Message = administrationroute.getMessage();
        if (art57Message != null) {
          administrationroutes.push(art57Message);
        }
      });
  
      if (this.children!.length > 0) {
        return {
          administrationroutes: { administrationroute: administrationroutes },
        };
      } else {
        return;
      }
    }

    override isStandardTerminology():boolean{
      return true;
    }
  
    override getHeaders(): string[] {
      return ['EV Code', 'Operation Type', 'Type', 'Administration Route'];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeRoutesOfAdministrationList =
        new TreeNodeRoutesOfAdministrationList(this.ioc!, newParent);
  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  }
  